export default [
  /** 儲值虚拟币 */
  {
    path: '/saving',
    name: 'Saving',
    component: () => import('@/upgrade-page/views/saving/index'),
    meta: {
      hideNav: true,
      needLogin: true,
      pageWidth: 980,
    }
  },
  /** 儲值虚拟币 */
  {
    path: '/saving_hk',
    name: 'Saving_hk',
    component: () => import('@/upgrade-page/views/saving/index'),
    meta: {
      hideNav: true,
      needLogin: true,
      pageWidth: 980,
    }
  },
  /** 儲值虚拟币 */
  {
    path: '/saving_tw',
    name: 'Saving_tw',
    component: () => import('@/upgrade-page/views/saving/index'),
    meta: {
      hideNav: true,
      needLogin: true,
      pageWidth: 980,
    }
  },
  /** 優惠券 */
  {
    path: '/coupons',
    name: 'Coupons',
    component: () => import('@/upgrade-page/views/coupons/index'),
    meta: {
      pageWidth: 980,
      needLogin: true,
    }
  },
  /** 快速提現申請 */
  {
    path: '/withdraw/quick',
    name: 'QuickWithdrawalBenefit',
    component: () => import('@/upgrade-page/views/withdrawalBenfit/quickWithdrawalBenefit'),
    meta: {
      hideNav: true,
    }
  },
  // 申請提領成功頁面
  {
    path: '/withdraw/quick-success',
    name: 'QuickWithdraSuccess',
    component: () => import('@/upgrade-page/views/withdrawalBenfit/quickWithdraBenSuc'),
    meta: {
      hideNav: true,
    }
  },
  /** 轉入餘額 */
  {
    path: '/transfer-balance',
    name: 'transferBalance',
    component: () => import('@/upgrade-page/views/transfer-balance'),
    meta: {
      hideNav: true,
      showBack: true,
      needLogin: true,
    }
  },
  // 蓝新提领
  {
    path: '/withdraw-info',
    name: 'WithdrawInfo',
    component: () => import('@/upgrade-page/views/withdraw/save-info'),
    meta: {
      hideNav: true,
      needLogin: true,
    }
  },
  // 提领页面
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/upgrade-page/views/withdraw/index'),
    meta: {
      needLogin: true,
      hideNav: true,
      showBack: true,
      pageWidth: 980,
    }
  },
  // 提領帳號認證信息編輯
  {
    path: '/withdraw-account',
    name: 'WithdrawAccount',
    component: () => import('@/upgrade-page/views/withdrawalBenfit/withdraw-info'),
    meta: {
      needLogin: true,
      hideNav: true,
      showBack: true,
      pageWidth: 980,
    }
  },
  // 提領帳號認證信息編輯
  {
    path: '/rebate-rule',
    name: 'RebateRule',
    component: () => import('@/upgrade-page/views/sale/rebate.vue'),
    meta: {
      needLogin: false,
      hideNav: true,
      pageWidth: '100%',
    }
  },
    /** 儲值钻石 */
    {
      path: '/diamond-recharge',
      name: 'DiamondRecharge',
      component: () => import('@/upgrade-page/views/diamond-recharge/index'),
      meta: {
        hideNav: true,
        needLogin: true,
        pageWidth: 980,
      }
    },
]